import React from "react";

import { StyledGrid } from "components/simple";

import Overview from "./Overview";
import { NewCycle } from "models/userAssessmentCycle";
import { FactorInfo } from "models/bhi";
import { PillarName } from "models/score";

interface BrainHealthIndexProps {
  currentCycleIndex: number;
  cycles: NewCycle[];
  selectedFactor?: PillarName;
  factorInfo: FactorInfo[];
}

const BrainHealthIndex: React.FC<BrainHealthIndexProps> = ({
  currentCycleIndex,
  cycles,
  selectedFactor,
  factorInfo
}) => {
  return (
    <StyledGrid container item justifyContent="center">
      <Overview
        cycles={cycles}
        selectedCycleIndex={currentCycleIndex}
        selectedFactor={selectedFactor}
        factorInfo={factorInfo}
      />
    </StyledGrid>
  );
};

export default BrainHealthIndex;
